import React, { useEffect, useState } from 'react';
import apiClient from 'apiClient';
import ErrorManager from 'shared/Messages/ErrorManager';
import SearchFirm from 'components/Advisers/SearchFirm';
import { FirmData } from 'components/Advisers/interface/advisersInterface';
import NotFound from 'components/Advisers/NotFound';
import { useSelector } from 'react-redux';
import { getIsLoggedIn } from 'auth/store/selectors';

const AdvisersPage: React.FC = () => {
  const [searchText, setSearchText] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [firms, setFirms] = useState<FirmData[]>([]);
  const [hasResults, setHasResults] = useState<boolean>(false);
  const [searchPerformed, setSearchPerformed] = useState<boolean>(false);
  const isUserLogged = useSelector((state: any) => getIsLoggedIn(state));

  useEffect(() => {
    setHasResults(firms.length > 0);
  }, [firms]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value);

  const handleSearchClick = async () => {
    setSearchPerformed(false);

    try {
      const res = await apiClient.get(`/api/v1/broker-management/firms-short/?search=${searchText}`);
      const data = res.data;
      setFirms(data);
    } catch (error) {
      setError(error.response);
    } finally {
      setSearchPerformed(true);
    }
  };

  const transformSearchData = (data: FirmData[]) => {
    const transformedData = data.map((item) => [
      { label: 'FCA Registration Number', value: item.fca.number, id: item.id },
      { label: 'Company Name', value: item.name },
    ]);

    return transformedData;
  };

  const transformedData = transformSearchData(firms);

  return (
    <>
      <SearchFirm
        searchText={searchText}
        handleSearchChange={handleSearchChange}
        handleSearchClick={handleSearchClick}
        data={transformedData}
      />
      {error && <ErrorManager error={error} />}
      {!hasResults && searchPerformed && !isUserLogged && <NotFound />}
    </>
  );
};

export default AdvisersPage;
